import WaitingIcon from './WaitingIcon';

export default WaitingIcon;
